/** @jsxImportSource @emotion/react */

import Modal from "react-modal";
import styled from "@emotion/styled";
import GoogleLogo from "../../../assets/imgs/google-logo.png";
import { TCalendarVisit, TVisit } from "apis/visitors/type";
import { useEffect, useState } from "react";
import { getVisitRecord } from "apis/visitors";
import { addPersonalCalendar } from "apis/visitors/personal-calendar";
import { AttendeeSection, ButtonGroup, DateSection, MemoSection, TimeSection, TitleSection } from "../add-personal-calendar";

const modalStyle = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        width: "500px",
        borderRadius: "20px",
        transform: "translate(-50%, -50%)",
    },
    overlay: {
        backgroundColor: "var(--component-color-material-dimmer)",
        zIndex: 1000,
    },
};
Modal.setAppElement("#root");

type Props = {
    modalIsOpen: boolean;
    closeModal: () => void;
    id: string;
};

const Title = styled.p`
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px;
    gap: 40px;
`;

const LinkCalendarModal = (props: Props) => {
    const { modalIsOpen, closeModal, id } = props;
    const [visitRecord, setVisitRecord] = useState<TVisit>();
    const [calendar, setCalendar] = useState<TCalendarVisit>();

    useEffect(() => {
        if (id) {
            getVisitRecord(id).then((res) => {
                if (res) {
                    const tempTime = new Date(res.visitDatetime);
                    setVisitRecord(res);
                    setCalendar({
                        visitRecordId: id,
                        startTime: res.visitDatetime,
                        endTime: new Date(tempTime.getTime() + 60 * 60 * 1000).toISOString(),
                        title: `${res.host.nickname}의 ${res.visitors[0].name}${
                            res.visitors.length > 1 ? ` 외 ${res.visitors.length - 1}명` : ""
                        } 미팅`,
                        description: "",
                        attendees: [],
                    });
                } else {
                    alert("권한이 없는 접근입니다.");
                    window.location.href = "/";
                }
            });
        }
    }, [id]);

    return (
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
            {visitRecord && (
                <ModalContainer>
                    <Title>
                        <img src={GoogleLogo} width={24} />
                        캘린더 일정 추가
                    </Title>
                    <TitleSection
                        title={calendar?.title}
                        onChange={(value: string) => {
                            setCalendar((prev) => {
                                return { ...prev, title: value };
                            });
                        }}
                    />
                    <DateSection dateTime={visitRecord.visitDatetime} />
                    <TimeSection
                        dateTime={visitRecord.visitDatetime}
                        endTime={new Date(`${calendar?.endTime}`)}
                        onChange={(end) => {
                            setCalendar((prev) => {
                                return { ...prev, endTime: end.toISOString() };
                            });
                        }}
                    />
                    <AttendeeSection
                        visitors={visitRecord.visitors}
                        managers={visitRecord.visitRecordManagers}
                        onChange={(users) => {
                            setCalendar((prev) => {
                                return { ...prev, attendees: users };
                            });
                        }}
                    />
                    <MemoSection
                        onChange={(value) => {
                            setCalendar((prev) => {
                                return { ...prev, description: value };
                            });
                        }}
                    />
                    <ButtonGroup
                        onHandleRegister={async () => {
                            if (calendar) {
                                const res = await addPersonalCalendar(calendar);
                                if (res.success) {
                                    alert("등록이 완료되었습니다.");
                                    closeModal();
                                }
                            }
                        }}
                        onHandleSkip={() => closeModal()}
                    />
                </ModalContainer>
            )}
        </Modal>
    );
};

export default LinkCalendarModal;
